<button mat-icon-button (click)="openMenu($event)" [mat-menu-trigger-for]="optionsMenu">
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #optionsMenu>
  <button mat-menu-item (click)="openRefundDialog()">
    {{ 'PAYMENTS_PAGE.REFUND' | translate }}
  </button>
  @if (displayIssueCreditNoteAction) {
    <button mat-menu-item (click)="issueCreditNoteAction()">
      {{ 'PAYMENTS_PAGE.ISSUE_CREDIT_NOTE' | translate }}
    </button>
  }
</mat-menu>
